// Pure: turn a CRM contact, pipeline record and/or transaction into the quick "who is this?" summary
// shown in the Person peek panel. No Firebase here so it can be unit tested.
const joinName = (o) => (o ? ([o.firstName, o.lastName].filter(Boolean).join(' ') || o.name || o.clientName || '') : '');
const first = (...v) => v.find((x) => x != null && String(x).trim() !== '') || '';
const dateOnly = (v) => (v ? String(v).slice(0, 10) : '');

export const telHref = (p) => { const d = String(p || '').replace(/[^0-9+]/g, ''); return d ? `tel:${d}` : ''; };
export const mailHref = (e) => (/^[^\s@]+@[^\s@]+$/.test(String(e || '').trim()) ? `mailto:${String(e).trim()}` : '');

export const buildPersonSummary = ({ contact, rec, recKind, transaction, team = [], activity = [], fallbackName = '' } = {}) => {
  const c = contact || {}; const r = rec || {}; const t = transaction || {};
  const agentId = first(c.assignedToId, r.assignedToId, c.ownerId, r.ownerId, t.ownerUid);
  const agent = (team || []).find((m) => m.uid === agentId);
  const notes = (activity || [])
    .filter((a) => a && (a.text || a.note || a.summary))
    .sort((a, b) => String(b.at || '').localeCompare(String(a.at || '')))
    .slice(0, 3)
    .map((a) => ({ text: String(a.text || a.note || a.summary), at: dateOnly(a.at), type: a.type || '' }));
  const lastContactEntry = (activity || []).filter((a) => a && /call|text|sms|email|meeting|appointment/i.test(a.type || '')).sort((a, b) => String(b.at || '').localeCompare(String(a.at || '')))[0];
  const stage = first(r.status, r.stage, c.status, c.stage, t.status);
  let fullLink = '';
  if (contact) fullLink = `/leads/contacts?id=${contact.id}`;
  else if (rec) fullLink = `/pipeline?${recKind === 'Buyer' ? 'view=buyer&' : ''}open=${rec.id}`;
  else if (transaction && transaction.id) fullLink = `/transactions/${transaction.id}`;
  return {
    name: first(joinName(c), joinName(r), joinName(t), fallbackName) || 'Unknown',
    kind: contact ? 'Lead' : rec ? `${recKind || 'Pipeline'} pipeline` : transaction ? 'Transaction client' : '',
    phone: first(c.phone, r.phone, t.phone),
    email: first(c.email, r.email, t.email),
    source: first(c.source, c.leadSource, r.leadSource, r.source, t.leadSource),
    added: dateOnly(first(c.createdAt, r.createdAt, t.createdAt)),
    stage,
    agent: agent ? agent.name : '',
    address: first(t.propertyAddress, r.propertyAddress, c.propertyAddress, c.address),
    transactionId: t.id || '',
    closingDate: dateOnly(first(t.closingDate, t.anticipatedClosingDate)),
    pinnedNote: first(c.pinnedNote && (c.pinnedNote.text || c.pinnedNote), c.latestNote && c.latestNote.text, c.notes, r.notes, t.notes),
    notes,
    lastContact: lastContactEntry ? `${dateOnly(lastContactEntry.at)} (${lastContactEntry.type})` : dateOnly(first(c.lastContactedAt, c.lastContact, r.lastContactedAt)),
    dnc: !!c.dnc,
    fullLink,
  };
};
